/** The parts of the dashboard the tour points at (see DashboardTour.tsx). */
export type TourTargetName =
  | 'add-word'
  | 'review'
  | 'public-decks'
  | 'follow'
  | 'import'
  | 'up-next'
  | 'known-add'
  | 'cards'
  | 'remind'
  | 'per-review'
  | 'new-words';

/** Marks an element as a tour target: `<Button {...tourTarget('add-word')}>`. */
export const tourTarget = (name: TourTargetName) => ({ 'data-tour': name });

/** The element on the page, or null while its tab has not drawn it yet. */
export const findTourTarget = (name: TourTargetName): HTMLElement | null =>
  document.querySelector<HTMLElement>(`[data-tour="${name}"]`);
